import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { QtyControl } from '../SingleItem/QtyControl/QtyControl.jsx';
import { PriceCell } from '../SingleItem/PriceCell/PriceCell.jsx';
import { DeleteIcon } from '../SingleItem/DeleteIcon/DeleteIcon.jsx';
import { EditableLabel } from './EditableLabel/EditableLabel.jsx';
import { ExtraGroupMenu } from './ExtraGroupMenu/ExtraGroupMenu.jsx';
import { ExpandToggle } from './ExpandToggle/ExpandToggle.jsx';
import { Items } from './Items/Items.jsx';
import { NotifyPopUp } from './NotifyPopup/NotifyPopUp.jsx';
import { EditableConfiguration } from './EditConfiguration/EditConfiguration.jsx';
import * as constants from '../../../constants/constants';

class ConfigurationGroupComponent extends Component {
  remove = () => {
    const { group } = this.props;

    group.remove({ withoutConfirm: true });
  };

  render() {
    const { optionsStore, labelsStore, uiStore, group } = this.props;
    const isDisabled = group.isDisabled ? 'disabled' : '';
    const isSubstitute = group.source === constants.substitute;
    const title = isSubstitute
      ? <h2 className="cart-group__title cart-group__title--wrap">{group.name}</h2>
      : <EditableLabel item={group} />;

    return (
      <section className={`cart-group indent-words ${group.pendingState} ${isDisabled}`}>

        <div className="cart-table__row cart-group__caption">

          <div className={`cart-group__name ${isSubstitute ? 'cart-group__name--wide' : ''}`}>
            {title}
          </div>

          {!uiStore.isMiddleRes && (
            <div className="cart-table__column cart-table__column--wide edit-configuration">
              <EditableConfiguration item={group} />
            </div>
          )}

          <ExtraGroupMenu item={group} containerClasses="cart-table__column cart-table__column--small extra-block" />

          <div className="cart-table__column cart-table__column--small quantity">
            <QtyControl item={group} isEditable />
          </div>

          {optionsStore.isPriceEnabledOnSite && (
            <div className="cart-table__column cart-table__column--small price">
              <PriceCell item={group} measure={labelsStore.pricePerGroup} />
            </div>
          )}

          {optionsStore.isWeeePricesVisible && <div className="cart-table__column cart-table__column--weee-prices" />}

          <div className="cart-table__column cart-table__column--delete">
            <DeleteIcon onClickHandler={this.remove} />
          </div>

          {group.isClipboardNotify && <NotifyPopUp content={group.codification} />}
        </div>

        <Items group={group} />

        <ExpandToggle item={group} />

      </section>
    );
  }
}

ConfigurationGroupComponent.propTypes = {
  group: propTypes.shape({
    selectCards: propTypes.object,
    isShown: propTypes.bool,
    remove: propTypes.func,
    pendingState: propTypes.string,
    configurationMasterId: propTypes.string,
    codification: propTypes.string,
    isDisabled: propTypes.bool,
    source: propTypes.string,
    name: propTypes.string,
    isClipboardNotify: propTypes.bool
  }).isRequired,

  optionsStore: propTypes.shape({
    isPriceEnabledOnSite: propTypes.bool,
    isWeeePricesVisible: propTypes.bool
  }).isRequired,

  labelsStore: propTypes.shape({
    pricePerGroup: propTypes.string,
    clipboardCopied: propTypes.string,
    editConfiguration: propTypes.string
  }).isRequired,

  uiStore: propTypes.shape({
    isMiddleRes: propTypes.bool
  }).isRequired

};

export const ConfigurationGroup = inject('labelsStore', 'optionsStore', 'uiStore')(observer(ConfigurationGroupComponent));
